/**
 * Opciones controladas de cliente CRM para moodboard (sin texto libre).
 * Excluye Inditex corporativo (no es línea de cliente usable).
 */
export function isExcludedMoodboardCustomer(name) {
  return String(name || "")
    .trim()
    .toUpperCase()
    .includes("INDITEX");
}

export function optionsFromCustomers(customersList) {
  return (Array.isArray(customersList) ? customersList : [])
    .filter((c) => !isExcludedMoodboardCustomer(c?.name))
    .map((c) => ({
      id: Number(c.id),
      label: String(c.name || "").trim() || `Cliente #${c.id}`,
    }))
    .filter((opt) => Number.isInteger(opt.id) && opt.id > 0)
    .sort((a, b) => a.label.localeCompare(b.label, "es"));
}

/**
 * Prefill solo si el cliente de la reunión está en el catálogo CRM.
 * Nunca inventa opciones fuera de la lista.
 */
export function matchClientOption(session, options) {
  const list = Array.isArray(options) ? options : [];
  if (!list.length) return null;

  const contacts = Array.isArray(session?.clientContacts)
    ? session.clientContacts
    : [];
  const firstWithId = contacts.find((c) => Number(c?.customerId) > 0);
  const destId = Number(firstWithId?.customerId || session?.customerId || 0);
  if (destId > 0) {
    const byId = list.find((o) => o.id === destId);
    if (byId) return byId;
  }

  const customerName = String(session?.customerName || "").trim();
  if (!customerName) return null;
  const lower = customerName.toLowerCase();
  return (
    list.find((o) => o.label.toLowerCase() === lower) ||
    list.find(
      (o) =>
        lower.includes(o.label.toLowerCase()) ||
        o.label.toLowerCase().includes(lower),
    ) ||
    null
  );
}
